/* @flow */
import * as React from 'react';
import PeopleListTableDataContainer from './PeopleListTableDataContainer.jsx';

export default class PeopleListTable extends React.Component<$FlowFixMeProps> {
  // TODO: define real prop types
  render() {
    return (
      <div>
        {/* Table options will go here */}
        <PeopleListTableDataContainer />
      </div>
    );
  }
}
